import { Post } from '../lib/api';

const normalize = (text?: string) => text?.toLowerCase().trim() || '';

/**
 * Determine whether a post matches a given joint type by checking both tags and text.
 * Handles the combined Foot & Ankle tag as well as legacy foot/ankle tags.
 */
export const matchesJointType = (
  post: Pick<Post, 'title' | 'description' | 'tags'>,
  jointType: string
) => {
  const normalizedJoint = normalize(jointType);
  const searchText = normalize(`${post.title || ''} ${post.description || ''}`);
  const tagTexts = (post.tags || []).map((tag) => normalize(tag.text));

  if (normalizedJoint === 'foot & ankle' || normalizedJoint === 'foot and ankle') {
    const hasFootAnkleTag = tagTexts.some(
      (text) => text === 'foot & ankle' || text === 'foot' || text === 'ankle'
    );
    const mentionedInText = searchText.includes('foot') || searchText.includes('ankle');
    return hasFootAnkleTag || mentionedInText;
  }

  return tagTexts.includes(normalizedJoint) || searchText.includes(normalizedJoint);
};
